module.exports = __webpack_public_path__ + "static/media/Cluster-4_2000.464b8934.jpg";